export const TRIGGER_API_ENDPOINT = '/api/workflows/triggerWorkflow';
export const API_ENDPOINT_TEXT_TEST_ID = 'api-endpoint-text';
export const API_ENDPOINT_URL_TEST_ID = 'api-endpoint-url';
export const LEARN_MORE_LINK_TEST_ID = 'learn-more-link';
export const tooltipText = {
  default: 'Copy to clipboard',
  inProgress: 'Copying...',
  success: 'Copied!',
  error: 'Error copying.  Please check browser settings.',
};
